// src/entry-client.js
import Vue from 'vue'
import { createApp } from './app'
import VueGtag from 'vue-gtag'
import VueConfirmDialog from 'vue-confirm-dialog'

Vue.use(VueConfirmDialog)

const { app, router, store } = createApp()

// ---------------- Browser-only plugins ----------------
if (typeof window !== 'undefined') {
  Vue.use(
    VueGtag,
    { 
      config: { id: 'G-XWNJ6LV2PG' }, 
      params: { 
        send_page_view: false,
        page_title: null
      },
      pageTrackerEnabled: false, // DISABLE auto tracking
      pageTrackerTemplate: null
    },
    router
  )


 console.log("APP VERSION - 2026-07-24 15:30");

  const VModal = require('vue-js-modal').default
  Vue.use(VModal, { dynamic: true, injectModalsContainer: true })

  // Add debug interceptor temporarily
  if (process.env.NODE_ENV === 'development') {
    const originalGtag = window.gtag
    window.gtag = function() {
      console.log('🔍 GA Call:', Array.from(arguments))
      if (arguments[1] && arguments[1].page_title) {
        console.log('   Page Title:', arguments[1].page_title)
        if (arguments[1].page_title.includes('.vue')) {
          console.warn('⚠️ COMPONENT NAME DETECTED IN GA!')
        }
      }
      originalGtag.apply(this, arguments)
    }
  }
}

// ---------------- Hydrate store if SSR rendered ----------------
if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__)
}

// ---------------- GA: send page_view AFTER vue-meta has updated title ----------------
let lastSentKey = ''

function sendPageViewAfterMeta() {
  if (typeof window === 'undefined' || !window.gtag) return

  // Force vue-meta to apply the latest metaInfo
  const meta = app.$meta && app.$meta()
  if (meta && typeof meta.refresh === 'function') meta.refresh()

  Vue.nextTick(() => {
    requestAnimationFrame(() => {
      const path = window.location.pathname + window.location.search + window.location.hash

      // Get title from document
      let title = document.title || 'OddsGalore'
      
      // VALIDATE: Filter out component names and filenames
      const invalidPatterns = ['.vue', '.js', '.ts', '.html', '.css', 'Component', 'App']
      const isInvalid = invalidPatterns.some(pattern => title.includes(pattern))
      
      if (isInvalid || title === 'OddsGalore' || title === 'Vue App') {
        console.warn('⚠️ Invalid title detected in GA:', title)
        
        // Try to get a better title from the route
        const route = router.currentRoute
        
        // Method 1: Check route meta
        if (route.meta && route.meta.title) {
          title = route.meta.title
          console.log('Using route meta title:', title)
        } 
        // Method 2: Check component name (convert to readable format)
        else if (route.name) {
          title = route.name
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
          console.log('Using route name as title:', title)
        }
        // Method 3: Format the path
        else {
          const segments = path.split('/').filter(s => s)
          if (segments.length > 0) {
            title = segments[segments.length - 1]
              .split('-')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ')
            console.log('Using path segment as title:', title)
          }
        }
        
        // Manually update document title as fallback
        document.title = title
      }

      const key = `${path}||${title}`
      if (key === lastSentKey) return
      lastSentKey = key

      // Log what we're sending
      console.log('✅ GA Pageview sent:', { 
        page_title: title, 
        page_path: path,
        page_location: window.location.href
      })

      window.gtag('event', 'page_view', {
        page_title: title,
        page_location: window.location.href,
        page_path: path,
      })
    })
  })
}

// ---------------- Run on hydration + route changes ----------------
router.onReady(() => {
  router.beforeResolve(async (to, from, next) => {
    next()
  })

  app.$mount('#app')

  // Initial page view
  setTimeout(() => {
    sendPageViewAfterMeta()
  }, 100) // Small delay to ensure everything is ready

  // Subsequent SPA navigations
  router.afterEach(() => {
    setTimeout(() => {
      sendPageViewAfterMeta()
    }, 50)
  })
})